/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Create_TitleInputs */

const en_us2_gyms_create_title = /** @type {(inputs: Gyms_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New gym`)
};

const pt_br2_gyms_create_title = /** @type {(inputs: Gyms_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova academia`)
};

const es_419_gyms_create_title = /** @type {(inputs: Gyms_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo gimnasio`)
};

const pt_pt2_gyms_create_title = /** @type {(inputs: Gyms_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo ginásio`)
};

const fr_fr2_gyms_create_title = /** @type {(inputs: Gyms_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle salle`)
};

const de_de2_gyms_create_title = /** @type {(inputs: Gyms_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Studio`)
};

const it_it2_gyms_create_title = /** @type {(inputs: Gyms_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova palestra`)
};

/**
* | output |
* | --- |
* | "New gym" |
*
* @param {Gyms_Create_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_create_title = /** @type {((inputs?: Gyms_Create_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Create_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_create_title(inputs)
	if (locale === "es-419") return es_419_gyms_create_title(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_create_title(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_create_title(inputs)
	if (locale === "de-DE") return de_de2_gyms_create_title(inputs)
	if (locale === "it-IT") return it_it2_gyms_create_title(inputs)
	return en_us2_gyms_create_title(inputs)
});
export { gyms_create_title as "gyms.create_title" }